import React, {useState} from 'react';
import {withStyles} from '@material-ui/core';
import i18n from '../../i18n';
import Grid from "@material-ui/core/Grid/Grid";
import Paper from "@material-ui/core/Paper/Paper";
import List from "@material-ui/core/List/List";
import ListItem from "@material-ui/core/ListItem/ListItem";
import Typography from "@material-ui/core/Typography/Typography";
import EllipsisWithTooltip from "../Formater/EllipsisWithTooltip";
import _ from "lodash";
import Divider from "@material-ui/core/Divider";
import {blue, green} from "@material-ui/core/colors";

const renderDetailsRow = (label, value, classes) => {
    return (
        <ListItem key={Math.random()} dense className={classes.detailsRow}>
            <Grid container spacing={24}>
                <Grid item xs={4}>
                    <Typography
                        className={classes.detailsLabel}
                        component={'div'}
                        variant={'subtitle2'}>
                        {(<EllipsisWithTooltip>{label}</EllipsisWithTooltip>)}
                    </Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography
                        className={classes.detailsValue}
                        component={'div'}
                        variant={'body2'}>
                        {value}
                    </Typography>
                </Grid>
            </Grid>
        </ListItem>
    );
};


const PersonnelDetails = (props) => {

    const {
        classes,
        personnel
    } = props;

    const defaultWorkingTimes = {from: '07:00', to: '17:00', break: 90};
    const fridayWorkingTimes = {from: '07:00', to: '14:00', break: 60};
    const weekendWorkingTimes = {from: '00:00', to: '00:00', break: 0};
    const defaultWorkingDays = [
        defaultWorkingTimes,
        defaultWorkingTimes,
        defaultWorkingTimes,
        defaultWorkingTimes,
        fridayWorkingTimes,
        weekendWorkingTimes,
        weekendWorkingTimes
    ];

    const summerTimes = (typeof personnel.working_time_summer === 'string')
        && JSON.parse(personnel.working_time_summer);
    const winterTimes = (typeof personnel.working_time_winter === 'string')
        && JSON.parse(personnel.working_time_winter);

    const [workingTimeSummer] = useState(summerTimes ?? null);
    const [workingTimeWinter] = useState(winterTimes ?? null);

    return (
        <React.Fragment>
            <Grid container spacing={24} className={classes.vSpace}>

                <Grid item xs={12} md={6}>
                    <Paper className={classes.spaces} style={{height: '100%'}}>
                        <div className={classes.details}>
                            <List className={classes.fullWidth}>

                                {personnel.first_name && personnel.last_name &&
                                    renderDetailsRow(
                                        i18n.get('personnel.name'),
                                        personnel.last_name + ', ' + personnel.first_name,
                                        classes
                                    )}
                                {personnel.type_of_remuneration &&
                                    renderDetailsRow(
                                        i18n.get('personnel.form.type_of_remuneration'),
                                        i18n.get('personnel.form.remuneration_' + personnel.type_of_remuneration),
                                        classes
                                    )
                                }
                                {personnel.profession &&
                                    renderDetailsRow(
                                        i18n.get('personnel.form.profession'),
                                        personnel.profession.name,
                                        classes
                                    )
                                }
                            </List>
                        </div>
                    </Paper>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Paper className={classes.spaces} style={{height: '100%'}}>
                        <div className={classes.details}>
                            <List className={classes.fullWidth}>
                                {personnel.number && renderDetailsRow(
                                    i18n.get('personnel.number'),
                                    personnel.number, classes
                                )}
                                {personnel.editor &&
                                    renderDetailsRow(
                                        i18n.get('personnel.editor'),
                                        personnel.editor.name,
                                        classes
                                    )
                                }
                                {personnel.current_site_name &&
                                    renderDetailsRow(
                                        i18n.get('personnel.current_site'),
                                        personnel.current_site_name,
                                        classes
                                    )
                                }
                            </List>
                        </div>
                    </Paper>
                </Grid>

                {(summerTimes && winterTimes) && (
                    <Grid item xs={12} md={12}>
                        <Paper className={classes.spaces} style={{height: '100%'}}>
                            <Grid container spacing={0} className={classes.vSpace} style={{marginTop: 0}}>
                                <Grid item xs={12} md={6}>
                                    <Grid item xs={12}>
                                        <Typography className={classes.green}
                                                    style={{marginTop: 10, marginLeft: 15, fontSize: '1rem'}}>
                                            {i18n.get('personnel.form.summer')}
                                        </Typography>
                                    </Grid>
                                    <Grid container spacing={0} className={classes.vSpace} style={{marginTop: 0}}>
                                        <Grid item xs={4} md={4}>
                                            <div className={classes.details}>
                                                <List className={classes.fullWidth}>
                                                    {workingTimeSummer && workingTimeSummer.map((data, weekday) =>
                                                        renderDetailsRow(
                                                            i18n.get('personnel.form.from_' + weekday),
                                                            workingTimeSummer[weekday].from, classes
                                                        )
                                                    ).filter((data, weekDay) => weekDay <= 4)}
                                                </List>
                                            </div>
                                        </Grid>
                                        <Grid item xs={4} md={4}>
                                            <div className={classes.details}>
                                                <List className={classes.fullWidth}>
                                                    {workingTimeSummer && workingTimeSummer.map((data, weekday) =>
                                                        renderDetailsRow(
                                                            i18n.get('personnel.form.to'),
                                                            workingTimeSummer[weekday].to, classes
                                                        )
                                                    ).filter((data, weekDay) => weekDay <= 4)}
                                                </List>
                                            </div>
                                        </Grid>
                                        <Grid item xs={4} md={4}>
                                            <div className={classes.details}>
                                                <List className={classes.fullWidth}>
                                                    {workingTimeSummer && workingTimeSummer.map((data, weekday) =>
                                                        renderDetailsRow(
                                                            i18n.get('personnel.form.break'),
                                                            ((workingTimeSummer[weekday].break / 60) + 'h'), classes
                                                        )
                                                    ).filter((data, weekDay) => weekDay <= 4)}
                                                </List>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Grid item xs={12}>
                                        <Typography className={classes.blue}
                                                    style={{marginTop: 10, marginLeft: 15, fontSize: '1rem'}}>
                                            {i18n.get('personnel.form.winter')}
                                        </Typography>
                                    </Grid>

                                    <Grid container spacing={0} className={classes.vSpace} style={{marginTop: 0}}>
                                        <Grid item xs={4} md={4}>
                                            <div className={classes.details}>
                                                <List className={classes.fullWidth}>
                                                    {workingTimeWinter && workingTimeWinter.map((data, weekday) =>
                                                        renderDetailsRow(
                                                            i18n.get('personnel.form.from_' + weekday),
                                                            workingTimeWinter[weekday].from, classes
                                                        )
                                                    ).filter((data, weekDay) => weekDay <= 4)}
                                                </List>
                                            </div>
                                        </Grid>
                                        <Grid item xs={4} md={4}>
                                            <div className={classes.details}>
                                                <List className={classes.fullWidth}>
                                                    {workingTimeWinter && workingTimeWinter.map((data, weekday) =>
                                                        renderDetailsRow(
                                                            i18n.get('personnel.form.to'),
                                                            workingTimeWinter[weekday].to, classes
                                                        )
                                                    ).filter((data, weekDay) => weekDay <= 4)}
                                                </List>
                                            </div>
                                        </Grid>
                                        <Grid item xs={4} md={4}>
                                            <div className={classes.details}>
                                                <List className={classes.fullWidth}>
                                                    {workingTimeWinter && workingTimeWinter.map((data, weekday) =>
                                                        renderDetailsRow(
                                                            i18n.get('personnel.form.break'),
                                                            ((workingTimeWinter[weekday].break / 60) + 'h'), classes
                                                        )
                                                    ).filter((data, weekDay) => weekDay <= 4)}
                                                </List>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                )}
            </Grid>
        </React.Fragment>
    );
}

const styles = theme => ({
    previewIcon: {
        textAlign: 'center',
    },
    spaces: {
        padding: theme.spacing.unit * 1.5,
    },
    vSpace: {
        marginTop: theme.spacing.unit * 1.5,
        marginBottom: theme.spacing.unit * 1.5,
    },
    fullWidth: {
        width: '100%',
    },
    details: {
        display: 'flex',
        flexDirection: 'row',
        padding: 0,
        '&:last-child': {
            padding: 0,
        },
    },
    detailsLabel: {
        textAlign: 'right',
    },
    detailsValue: {
        '& > *': {
            ...theme.helpers.oneLiner,
        },
    },
    green: {
        color: green[600],
    },
    blue: {
        color: blue[600],
    },
});

export default withStyles(styles)(PersonnelDetails);
